import { useState } from "react";
import { Dialog } from "@mui/material";
import Button from "./DefaultButton";
import LabelComponent from "./LabelComponent";
import SelectComponent from "./SelectComponent";
import InputComponent from "./InputComponent";
import { ReactComponent as CrossCancelIcon } from "../../assets/images/crossIconAddTaskPodModal.svg";
import { ReactComponent as FullView } from "../../assets/images/icons/FullView.svg";
import { ReactComponent as ExtenedView } from "../../assets/images/icons/ExtendeView.svg";
import moment from "moment";
import ToggleMultiSwitch from "./ToggleMultiSwitch";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";

const CheckTypeAndReturnHtmlInput = ({ id, name, metaType, type, placeholder, value, onChange, options }) => {
  const [inputTypeData, setInputTypeData] = useState(value);

  if (type === "text") {
    if (metaType === "Hyperlink") {
      return (
        <span>
          <LabelComponent htmlFor={id || name} labelText={name} size="small" />
          <InputComponent
            id={id || name}
            type="text"
            placeholder={placeholder || `Enter Name`}
            value={inputTypeData?.textForUrl}
            onChange={(event) => {
              setInputTypeData({ ...inputTypeData, textForUrl: event?.target?.value });
              onChange({ ...inputTypeData, textForUrl: event?.target?.value });
            }}
          />
          <div className="block pb-[3px]"></div>
          <InputComponent
            id={id || name}
            type="text"
            placeholder={placeholder || `Enter URL`}
            value={inputTypeData?.url}
            onChange={(event) => {
              setInputTypeData({ ...inputTypeData, url: event?.target?.value });
              onChange({ ...inputTypeData, url: event?.target?.value });
            }}
          />
        </span>
      );
    } else {
      return (
        <span>
          <LabelComponent htmlFor={id || name} labelText={name} size="small" />
          <InputComponent
            id={id || name}
            type={type}
            placeholder={placeholder || `Enter ${name}`}
            value={inputTypeData}
            onChange={(event) => {
              setInputTypeData(event?.target?.value);
              onChange(event?.target?.value);
            }}
            maxLength={metaType === "Short Text" ? 30 : metaType === "Long Text" ? 100 : 200}
          />
        </span>
      );
    }
  } else if (type === "number") {
    return (
      <span>
        <LabelComponent htmlFor={id || name} labelText={name} size="small" />
        <InputComponent
          id={id || name}
          type={type}
          placeholder={placeholder}
          value={inputTypeData}
          onChange={(event) => {
            setInputTypeData(event?.target?.value);
            onChange(event?.target?.value);
          }}
        />
      </span>
    );
  } else if (type === "date") {
    // ---- For dateTime ----
    if (metaType === "dateTime") {
      return (
        <span>
          <LabelComponent htmlFor={id || name} labelText={name} size="small" />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              value={inputTypeData ? dayjs(inputTypeData, "DD MMM YYYY HH:mm") : null}
              onChange={(newValue) => {
                if (!newValue) {
                  setInputTypeData(null);
                  onChange(null);
                  return;
                }
                // Format: DD MMM YYYY HH:mm
                const formatted = dayjs(newValue).format("DD MMM YYYY HH:mm");
                setInputTypeData(formatted);
                onChange(formatted); // send date + time
              }}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  placeholder: "DD MMM YYYY HH:mm",
                },
              }}
            />
          </LocalizationProvider>
        </span>
      );
    }

    // ---- For date only ----
    else {
      return (
        <span>
          <LabelComponent htmlFor={id || name} labelText={name} size="small" />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={inputTypeData ? dayjs(inputTypeData, "DD MMM YYYY") : null}
              onChange={(newValue) => {
                if (!newValue) {
                  setInputTypeData(null);
                  onChange(null);
                  return;
                }
                // Format: DD MMM YYYY
                const formatted = dayjs(newValue).format("DD MMM YYYY");
                setInputTypeData(formatted);
                onChange(formatted); // send only date
              }}
              format="DD MMM YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  placeholder: "DD MMM YYYY",
                },
              }}
            />
          </LocalizationProvider>
        </span>
      );
    }
  } else if (type === "dropdown") {
    return (
      <span>
        <LabelComponent htmlFor={id || name} labelText={name} size="small" />
        <SelectComponent
          id={id || name}
          label={name}
          options={options}
          value={value}
          onChange={(value) => {
            onChange([{ ...value[0] }]);
          }}
          noFormInput={true}
        />
      </span>
    );
  } else if (type === "multiselect") {
    return (
      <span>
        <LabelComponent htmlFor={id || name} labelText={name} size="small" />
        <SelectComponent
          id={id || name}
          label={name}
          options={options}
          value={value}
          onChange={(list) => {
            const modifiedList = list?.map((element) => {
              return { ...element };
            });

            onChange(modifiedList);
          }}
          noFormInput={true}
          multiSelect={true}
        />
      </span>
    );
  } else if (type === "person" || type === "multi_person") {
    return (
      <span>
        <LabelComponent htmlFor={id || name} labelText={name} size="small" />
        <SelectComponent
          id={id || name}
          label={name}
          options={options}
          value={inputTypeData || []}
          onChange={(list) => {
            setInputTypeData(list);
            onChange(list);
          }}
          personList
          multiSelect={type === "multi_person"}
          noFormInput={true}
          showSearch={true}
        />
      </span>
    );
  } else {
    return (
      <span>
        <LabelComponent htmlFor={id || name} labelText={name} size="small" />
        <InputComponent
          id={id || name}
          type="text"
          placeholder={placeholder || `Enter ${name}`}
          value={value}
          onChange={(event) => onChange(event?.target?.value)}
        />
      </span>
    );
  }
};

const TableListRowAddEditComponent = ({ mode = "add", open, onClose, onSubmit = () => {}, prefilledFormData = [] }) => {
  const [toggleValue, setToggleValue] = useState("full");
  const [formInputData, setFormInputData] = useState(prefilledFormData);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <div className="flex justify-between items-center p-3 border-b-[1px] border-[#D2DAE1]">
        <span className="text-base font-semibold text-primary">{mode === "add" ? "Add" : "Edit"} Item</span>
        <div className="flex gap-4 items-center">
          <ToggleMultiSwitch
            className="w-fit h-fit"
            onToggle={(value) => setToggleValue(value)}
            options={[
              {
                label: (
                  <FullView fill={toggleValue === "full" ? "var(--color-primary)" : "#8E8E8E"} className="p-[2px]" />
                ),
                value: "full",
              },
              {
                label: (
                  <ExtenedView
                    fill={toggleValue === "extened" ? "var(--color-primary)" : "#8E8E8E"}
                    className="p-[2px]"
                  />
                ),
                value: "extened",
              },
            ]}
            defaultValue="full"
          />
          <CrossCancelIcon className="cursor-pointer" onClick={onClose} />
        </div>
      </div>

      <form
        onSubmit={() => onSubmit(formInputData)}
        className={`p-3 grid ${toggleValue === "full" ? "grid-cols-1" : "grid-cols-2"} gap-2 overflow-y-auto`}
      >
        {prefilledFormData?.map((inputData) => (
          <div key={inputData?.name}>
            {CheckTypeAndReturnHtmlInput({
              id: inputData?.id,
              name: inputData?.name,
              type: inputData?.type,
              placeholder: inputData?.placeholder,
              value: inputData?.value,
              options: inputData?.options,
              metaType: inputData?.columnMetaType,
              onChange: (value) => {
                setFormInputData((prev) =>
                  prev.map((item) => (item?.name === inputData?.name ? { ...item, value } : item))
                );
              },
            })}
          </div>
        ))}
      </form>
      <div className="p-3 col-span-full flex justify-end gap-2">
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button onClick={() => onSubmit(formInputData)} type={"submit"} variant="primary">
          Save
        </Button>
      </div>
    </Dialog>
  );
};

export default TableListRowAddEditComponent;
